export default "__VITE_ASSET__HY_ln7Gn__"